import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, inject, provideAppInitializer, provideZoneChangeDetection, isDevMode } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { environment } from '../environments/environment';

import { routes } from './app.routes';
import { RouterService } from './core/services/router.service';
import { SwUpdateService } from './core/services/sw.update.service';
import { UserActivityListenerService } from './core/services/user.activity.listener.service';
import { LOCALSTORAGE, SESSIONSTORAGE } from './core/store/store.accessor';
import { NotificationsUtil } from './core/util/notifications.util';
import { PayloadUtil } from './core/util/payload.util';
import { RestPoliceService } from './rest/police.service';
import { RestUserService } from './rest/user.service';
import { ImportantMessageService } from './shared/building-blocks/important-message/important-message.service';
import { SnackbarService } from './shared/building-blocks/snackbar/snackbar.service';
import { provideServiceWorker } from '@angular/service-worker';

export const appConfig: ApplicationConfig = {
  providers: [
    PayloadUtil,
    NotificationsUtil,
    RestUserService,
    RestPoliceService,
    RouterService,
    SnackbarService,
    ImportantMessageService,
    SwUpdateService,
    provideAnimations(),
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptorsFromDi()),
    provideAppInitializer(() => {
      inject(UserActivityListenerService)
        .start();
    }),
    {
      provide:  LOCALSTORAGE,
      useValue: localStorage
    },
    {
      provide:  SESSIONSTORAGE,
      useValue: sessionStorage
    },
    provideServiceWorker('ngsw-worker.js', {
      enabled:              environment.serviceWorker,
      registrationStrategy: 'registerWhenStable:30000'
    })
  ]
};
